import React, { useRef } from 'react'
import PropTypes from 'prop-types'
function SimpleCheckbox (props) {
  const { label, className, callback, input, readOnly} = props
  let {value} = props;
  if(input){
    value = input.value
  }
  const checkboxEl = useRef(null)
  const renderCheckmark = () => {
    if(value){
      return (
        <div className='of-simple-checkbox__checkmark primary-background-1-100' >
          <i className='icon-of-tick-solid icon icon' />
        </div>
      )
    }
    return (
      <div className='of-simple-checkbox__checkmark of-simple-checkbox__checkmark--unchecked lines-border-2-100' />
    )
  }
  return (
    <div className={`of-simple-checkbox${className ? ' ' + className : ''}`}>
      <div className='of-simple-checkbox__wrapper' onClick={()=>{
        callback(!value)
      }}>
        {renderCheckmark()}
        <input {...input}
               ref={checkboxEl} type='checkbox' checked={value} className='of-simple-checkbox__field lines-border-2-100' onChange={() => {
          if(callback && !readOnly){
            callback(!value)
          }
        }}
        />
      </div>
      <div className='of-simple-checkbox__label text-font-1-100' onClick={()=>{callback(!value)}}>{label}</div>
    </div>
  )
}

SimpleCheckbox.propTypes = {
  label: PropTypes.any,
  value: PropTypes.bool,
  className: PropTypes.string,
  callback: PropTypes.func,
  input: PropTypes.any,
  readOnly: PropTypes.bool
}

export default SimpleCheckbox
